/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScriptRunnerComponentTypeEnum = 'IRR' | 'CDVX';

export const ScriptRunnerComponentTypeEnum = {

    IRR: 'IRR' as ScriptRunnerComponentTypeEnum,

    CDVX: 'CDVX' as ScriptRunnerComponentTypeEnum
};

